import styled, { Scale } from '@secretescapes/falcon';
import { type CommonStyledProps } from '@utils/styles.utils';

interface RecommendedSalesContainerProps extends CommonStyledProps {
  expiredSale?: boolean;
}

export const RecommendedSalesContainer = styled('div')<RecommendedSalesContainerProps>`
  padding: ${({ isMobile, expiredSale }) =>
    isMobile && expiredSale ? `0 ${Scale.m}` : !isMobile ? `${Scale.l} 0 0 0` : null};
  margin: ${({ isMobile, expiredSale }) =>
    isMobile
      ? `${Scale.l} 0 ${Scale.xl}`
      : expiredSale
        ? `${Scale.l} 0`
        : `-${Scale.l} 0 ${Scale.xxl}`};
`;

export const SeeDealsButtonWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  // Somehow spacing previously present has disappeared in RecommendedSection so adding one back in
  // Ideally RecommendedSalesContainer would just be flexbox with gap but Cauldron component has a random top padding
  margin-top: ${Scale.m};
`;
